import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_STRING } from '../../../constants/common'
import { useKeyboard } from '../../../hooks'
import { isEmptyString } from '../../../utils/common'
import {
  isEqualPagination,
  updatePaginationPage,
} from '../../../utils/pagination'
import { InputField } from '../../Input'
import Text from '../../Text'

import { TABLE_PAGINATION_PAGE_INPUT_REGEXP } from './TablePaginationPageInput.constants'

import * as styles from './TablePaginationPageInput.module.css'

function TablePaginationPageInput(props) {
  const { disabled, value: pagination } = props

  const [page, setPage] = useState(0)

  const { t } = useTranslation()

  function handleChange(e) {
    const { value } = e.target

    if (TABLE_PAGINATION_PAGE_INPUT_REGEXP.test(value)) {
      setPage(isEmptyString(value) ? 0 : parseInt(value, 10))
    }
  }

  function handleSubmit() {
    if (page !== 0) {
      const nextPagination = updatePaginationPage(pagination, page)

      setPage(0)

      if (!isEqualPagination(nextPagination, pagination)) {
        props.onSubmit(nextPagination)
      }
    }
  }

  useKeyboard(handleSubmit)

  return (
    <div className={styles.tablePaginationPageInput}>
      <Text
        isSecondary
        className={classNames(styles.text, { [styles.disabled]: disabled })}
      >
        {t('Table.GoToPageKey')}
      </Text>
      <InputField
        className={styles.input}
        disabled={disabled}
        height={24}
        value={page || EMPTY_STRING}
        onBlur={handleSubmit}
        onChange={handleChange}
      />
    </div>
  )
}

export default TablePaginationPageInput
